import { loadScript } from "../../../utils/js/utils.js";
import { readConfigPath } from "../../../utils/js/configMgr.js";
import events from "@trinitymirrordigital/chameleon-core/src/js/events";

export function init() {
  const siteOverrideId = readConfigPath("advertisingConfig.BARTSiteOverride");
  if (siteOverrideId) {
    loadBART(siteOverrideId);
  }
}

function loadBART(siteOverrideId) {
  const handleLoaded = () => {
    initGlobal(siteOverrideId);
    // wait for GPT to be ready before completing the initialization
    window.googletag.cmd.push(() => events.fire(window, "bart.loaded"));
  };

  if (window.__adVerification?.init) {
    handleLoaded();
  } else {
    const version = "2.0.1";
    const baseURL = `https://www.reachgeneric.co.uk/bad-ads-reporting-tool/js/AdVerification/verify-${version}.min.js`;
    // cachebuster rolls over every Monday 10am UTC
    const prevMonday = new Date();
    prevMonday.setUTCDate(
      prevMonday.getUTCDate() - ((prevMonday.getUTCDay() + 6) % 7)
    );
    prevMonday.setUTCHours(10, 0, 0, 0);
    const cachebuster = `?cb=${Date.parse(prevMonday) / 1000}`;
    loadScript(`${baseURL}${cachebuster}`).then(handleLoaded);
  }
}

function initGlobal(siteOverrideId) {
  window.__adVerification?.init(5293, siteOverrideId);
  // We need GPT to be ready before we init BART, so we use its cmd queue above
  window.googletag = window.googletag || { cmd: [] };
}
